(function () {
    'use strict';

    angular
        .module('app')
        .controller('SystemSettingEditCtrl', SystemSettingEditCtrl);

    /**
     * @ngdoc controller
     * @name SystemSettingEditCtrl
     *
     * @description
     * Edit screen for 'Other' system setting.
     */

    SystemSettingEditCtrl.$inject = [
        '$scope',
        '$q',
        '$routeParams',
        'SystemSettingsService',
        'LastUpdatedService',
        'NavigationAidService',
        'DialogService',
        'UnsavedChangesService',
        'ChilliUserProfileService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    function SystemSettingEditCtrl(
        $scope,
        $q,
        $routeParams,
        SystemSettingsService,
        LastUpdatedService,
        NavigationAidService,
        DialogService,
        UnsavedChangesService,
        ChilliUserProfileService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.systemSetting = {};
        vm.systemSetting.Id = $routeParams.id;
        vm.saveSystemSetting = saveSystemSetting;
        vm.deleteSystemSetting = deleteSystemSetting;
        vm.existingSystemSetting = existingSystemSetting;
        vm.close = close;
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        vm.viewTitle = 'System Setting';
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'systemSettingIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getLabel(vm.systemSetting); }
        });

        activate();
        
        function activate() {
            updateViewTitle();

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadSystemSetting,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    updateViewTitle();
                }
            });
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'System Setting';

            if (!_.isNil($routeParams.id) && $routeParams.id !== '') {
                if ($routeParams.id === 'new') {
                    title = 'Add ' + title;
                } else if (!_.isNil(vm.systemSetting) && !_.isNil(vm.systemSetting.Name) && vm.systemSetting.Name.length) {
                    title += ' - ' + vm.systemSetting.Name;
                }
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }


        /**
         * Load the system setting to the viewmodel, be it a new system setting or an existing one.
         *
         * @returns {promise} A promise that resolves once the system setting is loaded.
         */
        function loadSystemSetting() {
            var getSystemSettingPromise;

            if (!vm.systemSettingIsNew) {
                getSystemSettingPromise = SystemSettingsService.get($routeParams.id);
            } else {
                getSystemSettingPromise = $q.when(newSystemSetting());
            }

            return getSystemSettingPromise
                .then(getSystemSettingOk, getSystemSettingError);

            function getSystemSettingOk(data) {
                vm.systemSetting = data;

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.systemSetting',
                    saveFunction: saveSystemSetting,
                    unsavedItemName: 'System Setting'
                });
            }

            function getSystemSettingError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching System Setting', response);
                }
            }
        }


        /**
         * Save the system setting and navigate away from the system setting edit page.
         *
         * @returns {promise} A promise that resolves once the system setting has been saved.
         */
        function saveSystemSetting() {
            var promise = null;

            if (!_.isNil(vm.addSystemSettingForm) && vm.addSystemSettingForm.$invalid) {
                promise = DialogService.messageList('Error saving system setting', null, vm.addSystemSettingForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {
                promise = SystemSettingsService.save(vm.systemSetting)
                    .then(saveSystemSettingOk, saveSystemSettingError);
            }

            return promise;

            function saveSystemSettingOk(response) {
                if (vm.systemSettingIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('system/setting/other/' + response);
                } else {
                    vm.systemSetting = response;
                    vm.addSystemSettingForm.$setPristine();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.systemSetting',
                        saveFunction: saveSystemSetting,
                        unsavedItemName: 'System Setting'
                    });

                    updateViewTitle();
                }
            }

            function saveSystemSettingError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.systemSetting,
                    'System Setting',
                    vm.saveSystemSetting,
                    function () {
                        return SystemSettingsService.get($routeParams.id);
                    });
            }
        }

        /**
         * Creates a new system setting.
         *
         * @returns {object} A new system setting object.
         */
        function newSystemSetting() {
            return {
            };
        }

        /**
         * Check to see if the system setting is new or existing.
         */
        function existingSystemSetting() {
            var result = false;

            if (!angular.isUndefined(vm.systemSetting) && !angular.isUndefined(vm.systemSetting.Id) && vm.systemSetting.Id !== 'new') {
                result = true;
            }

            return result;
        }

        /**
         * Delete the system setting.
         */
        function deleteSystemSetting() {
            if ($routeParams.id && $routeParams.id !== 'new') {
                DialogService.confirm('Delete the System Setting?', 'System Setting delete confirm')
                    .then(deleteOk);
            }

            function deleteOk() {
                SystemSettingsService.remove($routeParams.id)
                    .then(deleteSystemSettingOk, deleteSystemSettingError);

                function deleteSystemSettingOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteSystemSettingError(response) {
                    DialogService.error('Error deleting System Setting', response);
                }
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();
